import { useCallback, useState } from "react";
import { MapContext, SetMapContext } from "./hooks/MapContext";

const MapProvider = MapContext.Provider;
const SetMapProvider = SetMapContext.Provider;

export default function MapContainer({ children }) {
  const [map, setMap] = useState(null);

  const handleSetMap = useCallback((newMap) => {
    setMap(newMap);
  }, []);

  return (
    <SetMapProvider value={handleSetMap}>
      <MapProvider value={map}>{children}</MapProvider>
    </SetMapProvider>
  );
}
